import React from 'react';
import { useRecoilValue } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import IncorrectPartNumber from 'pages/NewCaseSearch/subcomponents/IncorrectPartNumber';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import RequestReview from 'pages/NewCaseSearch/subcomponents/RequestReview';
import { Flex } from 'components/layout/Flex';

const OutOfWarrantyWithoutPrice = () => {
  const { lookupResults, selectedResult, reviewRequested } = useRecoilValue(
    lookupState
  );
  const { serialNumber, product } = selectedResult;
  const serialCard = [{ title: 'Serial #:', value: serialNumber }];
  const reviewCard = [];
  const outOfWarrantyMessage =
    'This item is not covered under warranty. Please proceed with submission and we will get back to you with the Out of Warranty information.';

  if (reviewRequested) {
    reviewCard.push({ title: 'Review Requested:', value: 'True' });
  }

  return (
    <Flex direction="column">
      {lookupResults.length === 1 ? (
        <Header cards={[...serialCard, ...reviewCard]} />
      ) : null}
      <Flex spacing="space-between">
        <Flex direction="column" spacing="space-between" grow="1">
          <Product statusMessage={outOfWarrantyMessage} {...product} />
          <RmaFiels />
        </Flex>
        <WarrantyActions>
          <AddToRma />
          {lookupResults.length === 1 && !reviewRequested ? (
            <IncorrectPartNumber />
          ) : null}
          <RequestReview />
        </WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default OutOfWarrantyWithoutPrice;
